import { Box, Button, Icon } from "@mui/material";
import { useEffect, useState } from "react";

export default function ScrollToTop() {
    const isScrollThresholdReached = () => {
        return document.documentElement.scrollTop > 500;
    };

    const [displayToTopEnabled, setDisplayToTopEnabled] = useState<boolean>(
        isScrollThresholdReached()
    );

    useEffect(() => {
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    });

    const onScroll = () => {
        setDisplayToTopEnabled(isScrollThresholdReached());
    };

    const scrollToTop = () => {
        window.scroll({ top: 0, left: 0, behavior: "smooth" });
    };

    return (
        displayToTopEnabled && (
            <Box
                sx={{ position: "fixed", bottom: 24, right: 24, zIndex: 99 }}
                onClick={scrollToTop}
            >
                <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<Icon>arrow_upward</Icon>}
                >
                    بازگشت به بالا
                </Button>
            </Box>
        )
    );
}
